var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border-brand-primary",attrs:{"id":"DmhSliderQuestion"}},_vm._l((_vm.question.sliders),function(question,i){return _c('Slider',{key:i,attrs:{"question":question,"updateAnswer":_vm.updateAnswer,"index":i}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }